import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../utils/scale-size';
import { Focusable, FocusableParent } from '../components/navigation';
import DeleteIcon from './Icons/delete';
import Tick from './Icons/tick';
import Platform from '../platform';

const StyledKeyboardWrapper = styled(FocusableParent)`
  width: ${scaleSize(300)}px;
  height: ${scaleSize(280)}px;
  font-size: ${scaleSize(32)}px;
  line-height: ${scaleSize(64)}px;
  padding: ${scaleSize(10)}px;
  border-radius: ${scaleSize(12)}px;
  background: #191919;
  position: absolute;
  right: 18%;
  top: 42%;
  z-index: 1;

  &:before {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    border: ${scaleSize(20)}px solid transparent;
    vertical-align: middle;
    position: absolute;
    top: 43%;
    left: -12%;
  }

  &:before {
    border-right-color: #191919;
  }
`;

const StyledKeyboarRow = styled.div`
  display: block;
  width: 100%;
`;
const StyledKeyboarDigit = styled(Focusable)`
  width: ${scaleSize(90)}px;
  height: ${scaleSize(60)}px;
  display: inline-block;
  text-align: center;
  border-radius: ${scaleSize(12)}px;
  margin: ${scaleSize(5)}px;
  background: ${({ theme }) => theme.backgroundLoaderColor};
  color: ${({ theme }) => theme.mainTextColor};

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    color: ${({ theme }) => theme.defaultColor};

    & svg > path {
      stroke: ${({ theme }) => theme.defaultColor};
      &:not([fill='none']) {
        fill: ${({ theme }) => theme.defaultColor};
      }
    }
  }
`;

const numKeys = [
  [{ title: '1' }, { title: '2' }, { title: '3' }],
  [{ title: '4' }, { title: '5' }, { title: '6' }],
  [{ title: '7' }, { title: '8' }, { title: '9' }],
  [{ title: 'remove', special: true }, { title: '0' }, { title: 'close', special: true }],
];

class KeyboardSmall extends Component {
  onEnter = character => {
    const { onEnter } = this.props;

    onEnter(character);
  };

  renderSpecialCharacter = special => {
    switch (special) {
      case 'remove':
        return <DeleteIcon />;
      case 'close':
        return <Tick />;
      default:
        break;
    }
  };

  onKeydown = ({ keyCode }) => {
    const numberValue = Platform.getKeyCodeNumericValue(keyCode);
    if (numberValue) this.props.onEnter(numberValue);
  };

  componentDidMount() {
    document.addEventListener('keydown', this.onKeydown, true);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeydown, true);
  }

  render() {
    return (
      <StyledKeyboardWrapper sectionName={'KEYBOARD_NUM'} defaultSection {...this.props}>
        {numKeys.map((row, i) => {
          return (
            <StyledKeyboarRow key={i}>
              {row.map((digit, j) => {
                return (
                  <StyledKeyboarDigit
                    key={j}
                    onEnter={() => this.onEnter(digit.title)}
                    focusOnMouseEnter
                  >
                    {digit.special ? this.renderSpecialCharacter(digit.title) : digit.title}
                  </StyledKeyboarDigit>
                );
              })}
            </StyledKeyboarRow>
          );
        })}
      </StyledKeyboardWrapper>
    );
  }
}

export default KeyboardSmall;
